export default function editHousingCorporationAddress(
  {patch}: any,
  {cid, address}: {cid: number; address: string},
): Promise<{}> {
  return patch(
    `/housing-corporations/address?corporationId=${cid}`,
    {address},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationAddress.tsx